<script lang="ts">
  /* Stats side by side, evenly divided, with a hairline between.
   *
   * This is a panel's headline block — the thing read before deciding whether
   * to open anything else, and the thing the sheet's peek line paraphrases.
   *
   * Two or three per row. Four `lg` stats across a 360 px panel column is
   * 90 px each, which is narrower than "21.4 nm" at 28 px.
   */
  import type { Snippet } from 'svelte';

  let { children }: { children: Snippet } = $props();
</script>

<div class="statrow">{@render children()}</div>

<style>
  .statrow {
    display: flex;
    gap: var(--sp-5);
  }
  /* `:global` because the children are `<Stat>`s the caller composed, and
     Svelte scopes to the markup this component declares. */
  .statrow > :global(*) {
    flex: 1 1 0;
    min-width: 0;
    padding-left: var(--sp-5);
    border-left: 1px solid var(--line);
  }
  .statrow > :global(:first-child) {
    padding-left: 0;
    border-left: 0;
  }
</style>
